import { TFunction } from 'i18next'
import appConfig from 'app.config'
import Axios from 'selfServicePortal/services/axios'
import { logError } from 'shared'
import {
	IInformationModalProps,
	InformationData,
} from 'shared/interfaces/i-api-informationModal'
import { informationModalToClientFormat } from 'shared/utils/informationModalToClientFormat'

export async function getInformationService(
	t: TFunction,
): Promise<IInformationModalProps[]> {
	try {
		const response = await Axios.get<InformationData>(
			`${appConfig.umbracoBaseUrl}/umbraco/delivery/api/v2/content`,
			{
				headers: {
					accept: 'application/json',
					'Api-Key': process.env.REACT_APP_UMBRACO_API_KEY,
				},
			},
		)

		const data = response.data.items
			.filter(
				(informatioModal) =>
					informatioModal.id !==
					'352c2832-52a6-49e8-b137-f496435dc5c7',
			)
			.map((information) =>
				informationModalToClientFormat(information.properties),
			)

		return data
	} catch (err: unknown) {
		logError(err as Error)
		if (
			(err as { response?: { status: number } }).response?.status === 404
		) {
			throw new Error(t('ErrorMsg'))
		} else {
			throw err
		}
	}
}
